import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Home, BookOpen, Sparkles, MessageCircle, MoreHorizontal, X } from "lucide-react";

const PRIMARY = [
  { to: "/", label: "Accueil", icon: Home, testid: "mnav-home", end: true },
  { to: "/conseils", label: "Conseils", icon: BookOpen, testid: "mnav-advice" },
  { to: "/activites", label: "Activités", icon: Sparkles, testid: "mnav-activities" },
  { to: "/coach", label: "Coach", icon: MessageCircle, testid: "mnav-coach" },
];

const PRIMARY_PATHS = PRIMARY.map((i) => i.to);

// Barre de navigation fixe, uniquement sur mobile.
export default function MobileNav({ items }) {
  const [open, setOpen] = useState(false);
  const rest = items.filter((i) => !PRIMARY_PATHS.includes(i.to));

  return (
    <>
      {open && (
        <div
          className="sm:hidden fixed inset-0 z-40 bg-black/30 backdrop-blur-sm"
          onClick={() => setOpen(false)}
          data-testid="mobile-more-overlay"
        >
          <div
            className="absolute bottom-[68px] left-3 right-3 rounded-3xl bg-white p-3 shadow-xl"
            onClick={(e) => e.stopPropagation()}
            data-testid="mobile-more-sheet"
          >
            <div className="grid grid-cols-3 gap-2">
              {rest.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  data-testid={`mnav-more-${item.testid}`}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `flex flex-col items-center gap-1.5 rounded-2xl px-2 py-3 text-xs font-medium transition-colors duration-200 ${
                      isActive ? "bg-[#23375E] text-white" : "bg-[#EDF2F9] text-[#16233D]"
                    }`
                  }
                >
                  <item.icon className="h-5 w-5" />
                  {item.label}
                </NavLink>
              ))}
            </div>
          </div>
        </div>
      )}

      <nav
        className="sm:hidden fixed bottom-0 left-0 right-0 z-50 border-t border-[#E3E8F1] bg-[#FAF8F5]/95 backdrop-blur-md pb-[env(safe-area-inset-bottom)]"
        data-testid="mobile-bottom-nav"
      >
        <div className="flex items-stretch">
          {PRIMARY.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={item.testid}
              className={({ isActive }) =>
                `flex-1 flex flex-col items-center justify-center gap-1 py-2.5 text-[11px] font-medium transition-colors duration-200 ${
                  isActive ? "text-[#23375E]" : "text-[#99A5BB]"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <span
                    className={`grid h-8 w-8 place-items-center rounded-xl transition-colors duration-200 ${
                      isActive ? "bg-[#D2EDE1]" : ""
                    }`}
                  >
                    <item.icon className="h-5 w-5" />
                  </span>
                  {item.label}
                </>
              )}
            </NavLink>
          ))}
          <button
            data-testid="mnav-more-btn"
            onClick={() => setOpen((v) => !v)}
            className={`flex-1 flex flex-col items-center justify-center gap-1 py-2.5 text-[11px] font-medium transition-colors duration-200 ${
              open ? "text-[#23375E]" : "text-[#99A5BB]"
            }`}
          >
            <span className={`grid h-8 w-8 place-items-center rounded-xl ${open ? "bg-[#D2EDE1]" : ""}`}>
              {open ? <X className="h-5 w-5" /> : <MoreHorizontal className="h-5 w-5" />}
            </span>
            Plus
          </button>
        </div>
      </nav>
    </>
  );
}
